/**
 * Maps a help section id to the component that renders it.
 *
 * The same shape as `helpIcons.ts`, and here for the same reason: `helpSections.ts` names
 * things by string, and something has to resolve those strings.
 *
 * WHY THIS IS NOT IN Help.tsx. Two reasons, and the second is the important one.
 * Exporting a non-component constant from a component file trips
 * `react-refresh/only-export-components`. More to the point, a section registered in
 * `HELP_SECTIONS` but missing from this map renders NOTHING, silently, because
 * `renderSectionCards` does `if (!ContentComponent) return null`. There is no error and no
 * empty card. That is what happened to Sales Trackers: it shipped over twelve commits from
 * 20 August, the gap was written into a change doc on 27 August, and it stayed invisible
 * because nothing tested the help system. Keeping the map in its own module lets
 * `config/__tests__/helpRegistration.test.ts` assert the two lists agree without importing
 * the page.
 */
import GettingStartedSection from '@/components/help/sections/GettingStartedSection'
import QuickStartSection from '@/components/help/sections/QuickStartSection'
import DashboardSection from '@/components/help/sections/DashboardSection'
import ActivitiesSection from '@/components/help/sections/ActivitiesSection'
import TicketingSection from '@/components/help/sections/TicketingSection'
import CrmSection from '@/components/help/sections/CrmSection'
import SalesSection from '@/components/help/sections/SalesSection'
import ContractReviewsSection from '@/components/help/sections/ContractReviewsSection'
import SalesWorkflowsSection from '@/components/help/sections/SalesWorkflowsSection'
import AnalyticsSection from '@/components/help/sections/AnalyticsSection'
import SalesTrackersSection from '@/components/help/sections/SalesTrackersSection'
import ContentSection from '@/components/help/sections/ContentSection'
import PipedriveSection from '@/components/help/sections/PipedriveSection'
import AdministrationSection from '@/components/help/sections/AdministrationSection'
import KeyboardShortcutsSection from '@/components/help/sections/KeyboardShortcutsSection'
import CommonTasksSection from '@/components/help/sections/CommonTasksSection'
import TipsSection from '@/components/help/sections/TipsSection'
import FaqSection from '@/components/help/sections/FaqSection'
import WhatsNewSection from '@/components/help/sections/WhatsNewSection'
import SupportSection from '@/components/help/sections/SupportSection'

export const sectionContentMap: Record<string, React.ComponentType> = {
  'getting-started': GettingStartedSection,
  'quick-start': QuickStartSection,
  dashboard: DashboardSection,
  activities: ActivitiesSection,
  ticketing: TicketingSection,
  crm: CrmSection,
  sales: SalesSection,
  'contract-reviews': ContractReviewsSection,
  'sales-workflows': SalesWorkflowsSection,
  analytics: AnalyticsSection,
  'sales-trackers': SalesTrackersSection,
  content: ContentSection,
  pipedrive: PipedriveSection,
  administration: AdministrationSection,
  'keyboard-shortcuts': KeyboardShortcutsSection,
  'common-tasks': CommonTasksSection,
  tips: TipsSection,
  faq: FaqSection,
  'whats-new': WhatsNewSection,
  support: SupportSection,
}
